import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"engagement-overview-wrapper\">\r\n    <section class=\"row\">\r\n        <section class=\"column small-10 small-centered\">\r\n            <h2 class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n        </section>\r\n    </section>\r\n\r\n    <section class=\"row\">\r\n        <div class=\"column small-6 small-centered\">\r\n            "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"choices") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":10,"column":38}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </section>\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"interstitialLanguageChange") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n</section>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/engagement-overview-module",
  "version": "1.0.3",
  "id": "engagementOverviewModule",
  "containerID": "homeLoansEngagementOverviewModule",
  "moduleName": "home-loans-engagement-overview-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "engagement-overview-module",
  "data": {
    "init": "engagementOverviewModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        select
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    select
  },
  "dependencies": {
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-underscore-dangle */

// below variables used for ADA keyboard events
let _mylink;
// specific to IE for select box
let _isIE;
let _isWIN;
let _spacebar;
let _isSpanishPage;
let _languageChangeLink;

/**
 * @export
 * @class engagementOverviewModule
 * @extends {Module}
 */
class engagementOverviewModule extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#engagementOverviewModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method updateLinksForSecure
   * @desc updates links using site parms to point to secure
   * @returns {void}
   */
  updateLinksForSecure() {
    // update links to handle subcampaign codes and
    // secure ones (prequality now, apply now, and schedule an appt)
    const $cache = $('div[id*="cta"] a[id*="ScheduleAppointment"],#contactUsModule a#schedule-appt'); // schedule appt cta + schedule appt contact us

    $.each($cache, (idx, val) => {
      const link = spaParams.siteParams.secureHost + $(val).attr('href');
      $(val).attr('href', link);
    });
  }

  /**
   * @method selectBoxChanged
   * @desc based on select changes navigates to page based on jcr data-attr
   * @param {object} e Event object
   * @returns {boolean} true
   */
  selectBoxChanged(e) {
    const $cache = this.$target.find(e.currentTarget);

    // get mappings for what drop down selected maps to link
    const mapping = $cache.attr('data-mapping-links');
    const mappingArr = mapping.split(';');

    // determine which element it is
    const selectedNumber = $cache.find(':selected').index();

    // get link from mappingArr
    const arrTemp = mappingArr.filter(a => {
      const temp = a.split('|');
      return temp[0] === selectedNumber.toString();
    });
    _mylink = arrTemp[0].split('|')[1]; // eslint-disable-line

    if (_mylink) {
      if (_isSpanishPage) {
        if (_mylink.includes('/es')) {
          window.location.href = _mylink;
        } else {
          _languageChangeLink.attr('href', _mylink);
          _languageChangeLink.click();
        }
      } else {
        window.location.href = _mylink;
      }
    }
    return true;
  }

  /**
   * @method updatePageLoadSelect
   * @desc selects first select option
   * @returns {void}
   */
  updatePageLoadSelect() {
    const $cache = this.$target.find('select');
    $cache.find('option:eq(0)').prop('selected', true);
    $cache.focusout();
  }

  /**
   * @method success
   * @param {object} response Response object
   * @returns {void}
   */
  success(response) {
    const payload = response.data;
    const $cache = $('.number');

    // set phone number in correct places
    if (payload.phoneNumber !== null) {
      let formattedPhone = payload.phoneNumber.split('-');
      formattedPhone = formattedPhone.join('.').replace(/[^\.0-9]/g, ''); // eslint-disable-line
      $cache.text(formattedPhone);
      $cache.attr('href', `tel:${formattedPhone.replace(/\./g, '')}`);
    }
  }

  /**
   * @method init
   * @desc Initialize module
   * @returns {void}
   */
  init() {
    this.$target.spartaInputs();

    // on page load set default select to index 0
    this.updatePageLoadSelect();

    // update links for secure
    this.updateLinksForSecure();

    // home loan phone number success
    this.Events.sub('HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS', this.success.bind(this));

    // fade page in after 150 ms to give sparta inputs a chance to render js on select box
    this.$target.find('.engagement-overview-wrapper').fadeIn(150);

    // select
    const myselect = this.$target.find('select');
    const {
      selectBoxChanged
    } = this;
    _isWIN = this.Store.getData('browser').win;

    // Internet Explorer 6-11
    _isIE = /* @cc_on!@ */!!document.documentMode;

    // Edge 20+
    if (!_isIE) {
      _isIE = !_isIE && !!window.StyleMedia;
    }

    // Check if page is spanish
    _isSpanishPage = window.location.pathname.includes('/es/');

    // find Language Change Link
    _languageChangeLink = $('#interstitial-Language-Change-link');

    // select on focus
    myselect.on('focus', () => {
      // Store the current value on focus and on change
      myselect.data('prev', myselect.val());
    });
    myselect.on('blur', () => {
      _spacebar = false;

      // Restore onChange event if unbound
      myselect.bind('change', selectBoxChanged);
    });
    myselect.on('mousedown', () => {
      _spacebar = false;
      myselect.bind('change', selectBoxChanged);
    });

    // on select keydown-ADA
    myselect.on('keydown', evt => {
      const charCode = evt.which ? evt.which : evt.keyCode;

      // escape key
      if (charCode === 27) {
        // this key is NOT fired in Chrome (Windows) if select box is opened
        if (_isWIN) {
          myselect.unbind('change');
        }
      }

      // tab key
      if (charCode === 9) {
        // this key is NOT fired in Chrome (Windows) if select box is opened
        if (_isWIN) {
          myselect.unbind('change');
        }
      }

      // up and down arrow keys
      if (charCode === 38 || charCode === 40) {
        // this key is NOT fired in Chrome (Windows) if select box is opened
        // added condition for IE - fix for JIRA ticket CFSSSPDLCE-19264
        if (_isWIN || _isIE) {
          myselect.unbind('change');
        }
      }

      // enter key
      if (charCode === 13) {
        // this key is NOT fired in Chrome (Windows) if select box is opened
        if (_isIE && _spacebar) {
          myselect.bind('change', selectBoxChanged);
        } else {
          selectBoxChanged(evt);
        }
      }

      // spacebar key
      if (charCode === 32) {
        _spacebar = true;
        if (_isWIN && !_isIE) {
          myselect.unbind('change');
        }
      }
      return true;
    });

    // on select change update box
    myselect.on('change', this.selectBoxChanged);
  }
}
registerModuleClass({
  moduleClass: engagementOverviewModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { engagementOverviewModule as default, moduleConfig };
